// ─────────────────────────────────────────────────────────────────────────────
// TechBench — Universe Map config
// ─────────────────────────────────────────────────────────────────────────────

export const ROLE_NAMES = {
  foundation: {
    it: 'IT Foundation Ready',
    hs: 'Human Skills Foundation',
    ai: 'AI Foundations',
  },
  t2: {
    hs:              'Professional Effectiveness',
    ai:              'AI Practitioner',
    infrastructure:  'Systems Engineer',
    itsm:            'IT Support Specialist',
    cloud:           'Cloud Associate',
    security:        'Security Analyst',
    'data-analytics':'Data Analyst',
  },
  t3: {
    hs:              'Leadership Foundations',
    ai:              'AI Integration',
    infrastructure:  'Infrastructure Engineer',
    itsm:            'ITSM Analyst',
    cloud:           'Cloud Engineer',
    security:        'Security Engineer',
    'data-analytics':'Senior Analyst',
  },
  t4: {
    hs:              'Senior Leadership',
    ai:              'AI Strategy',
    infrastructure:  'Senior Infrastructure Engineer',
    itsm:            'ITSM Manager',
    cloud:           'Senior Cloud Engineer',
    security:        'Senior Security Engineer',
    'data-analytics':'Analytics Engineer',
  },
}

// Tree identity colours — match the static learn-more.html tree cards exactly
export const TREE_COLORS = {
  infrastructure:  'blue',
  itsm:            'purple',
  cloud:           'cyan',
  security:        'red',
  'data-analytics':'orange',
}

export const TREE_IDS = [
  'infrastructure', 'itsm', 'cloud', 'security', 'data-analytics',
]

export const TREE_LABELS = {
  infrastructure:  'Infrastructure',
  itsm:            'ITSM',
  cloud:           'Cloud',
  security:        'Security',
  'data-analytics':'Data & Analytics',
}

// Capstone names per tree per tier
export const CAPSTONE_NAMES = {
  foundation: 'Getting Real',
  t2: {
    infrastructure:  'Systems Engineer',
    itsm:            'IT Support Specialist',
    cloud:           'Cloud Associate',
    security:        'Security Analyst',
    'data-analytics':'Data Analyst',
  },
  t3: {
    infrastructure:  'Infrastructure Engineer',
    itsm:            'ITSM Analyst',
    cloud:           'Cloud Engineer',
    security:        'Security Engineer',
    'data-analytics':'Senior Analyst',
  },
  t4: {
    infrastructure:  'Senior Infrastructure Engineer',
    itsm:            'ITSM Manager',
    cloud:           'Senior Cloud Engineer',
    security:        'Senior Security Engineer',
    'data-analytics':'Analytics Engineer',
  },
}

export const FOUNDATION_MODULES = {
  it: [
    { num: 'TS1', title: 'Hardware & Components',    module: 1 },
    { num: 'TS2', title: 'Networking & Connectivity', module: 2 },
    { num: 'TS3', title: 'Operating Systems',         module: 3 },
    { num: 'TS4', title: 'Mobile Devices & MDM',      module: 4 },
    { num: 'TS5', title: 'IT in Practice',            module: 5 },
  ],
  hs: [
    { num: 'HS1', title: 'Communication',            module: 1 },
    { num: 'HS2', title: 'Managing Yourself',        module: 2 },
    { num: 'HS3', title: 'Working with Others',      module: 3 },
    { num: 'HS4', title: 'Difficult Situations',     module: 4 },
    { num: 'HS5', title: 'Interview Prep',           module: 5 },
  ],
  ai: [
    { num: 'AI1', title: 'The Honest Picture',               module: 1 },
    { num: 'AI2', title: 'Working With AI',                  module: 2 },
    { num: 'AI3', title: 'Automation',                       module: 3 },
    { num: 'AI4', title: 'Risk & Responsibility',            module: 4 },
    { num: 'AI5', title: 'AI and the Shape of Your Career',  module: 5 },
  ],
}

export function findResumeLesson(lessonIndex, completedLessons, track) {
  const trackFilter = track === 'it'
    ? l => l.track === 'it' && l.type !== 'intro' && l.type !== 'ref' && l.type !== 'capstone'
    : track === 'hs'
    ? l => l.track === 'hs' && l.type !== 'intro' && l.type !== 'ref'
    : l => l.track === 'ai' && l.type !== 'intro' && l.type !== 'ref'
  return lessonIndex.filter(trackFilter).find(l => !completedLessons.includes(l.id)) || null
}

export function findGlobalResume(lessonIndex, completedLessons) {
  return lessonIndex
    .filter(l => l.type !== 'intro' && l.type !== 'ref' && l.type !== 'capstone')
    .find(l => !completedLessons.includes(l.id)) || null
}
